Backbone = require 'backbone'
parsedParams = new Backbone.Model()
handlers = {}

# returns params to be used in deal partial AJAX call
module.exports = BrowseParsedParamsHelper =
  setParsedParams: (params, options) ->
    # clears all existing values and is done to prevent
    # previous values from being re-used.  we don't want to
    # trigger the 'change' event more than once per
    # setParsedParams call, so silent:true is passed
    parsedParams.clear { silent: true }

    # set will update with new values, however we have to
    # manually trigger 'change' to handle the edge case
    # where all params are undefined, otherwise it will
    # not be triggered.  This happens when there are no
    # categories or sort and a 'reset' is requested
    parsedParams.set params, { silent: true }
    parsedParams.trigger 'change', parsedParams, options

  getParsedParams: ->
    parsedParams.toJSON()

  onUpdate: (cb, key) ->
    changeHandler = (model, options) ->
      cb model.toJSON(), options
    handlers[key] = changeHandler if key?
    parsedParams.on 'change', changeHandler

  # used to remove callbacks for tests
  offUpdate: (key) ->
    if handlers[key]
      parsedParams.off 'change', handlers[key]
      delete handlers[key]
